export function notNull(x) {
  return x !== undefined && x !== null && x !== '__null' && x !== '_null' ? x : null
}
